<template>
  <div class="jiceng">
    <div class="title animate__animated wow animate__fadeInUp">
      <titleCard title='基层肾病生态圈建设'></titleCard>
    </div>
    <div class="img1 animate__animated wow animate__fadeInUp">
      <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/CD2CEBFB4D924F5C9E663482DC82C2BC-6-2.png" alt="">
    </div>
    <h3 class="text animate__animated wow animate__fadeInUp">欢迎肾病相关领域合作伙伴加入、建立产业联盟，携手前行</h3>
    <titleCard title='运营模式' class="animate__animated wow animate__fadeInUp"></titleCard>
    <div class="yunying-card animate__animated wow animate__fadeInUp">
      <p>优 质 医 疗 资 源 下 沉</p>
      <div class="yunying-box">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/91921D2B9D114905B31AF672E82318F3-6-2.png" alt="">
      </div>
      <p>ckd 一 体 化 分 级 管 理</p>
    </div>
    <h4 class="text2">专科医联体网络</h4>
    <div class="quanyi animate__animated wow animate__fadeIn">
      <div class="top">
        <titleCard title='各方权益'></titleCard>
      </div>
      <div class="content animate__animated wow animate__bounceIn ">
        <h4>基层生态圈</h4>
        <div class="bordericon left-top">
          <p style="text-align: right;">节省医保开支<br>落实分级诊疗政策</p>
          <div class="icon">
            <img src="@/assets/image/innovatc/icon1.webp">
            <span>政府</span>
          </div>
        </div>
        <div class="bordericon left-bootom">
          <p style="text-align: right;">提升就医体验<br>节省医疗费用支出</p>
          <div class="icon">
            <img src="@/assets/image/innovatc/icon2.webp">
            <span>患者</span>
          </div>
        </div>
        <div class="bordericon right-top">
          <div class="icon">
            <img src="@/assets/image/innovatc/icon3.webp">
            <span>医院</span>
          </div>
          <p>加强学科建设<br>提高医护人员诊疗水平</p>
        </div>
        <div class="bordericon right-bottom">
          <div class="icon">
            <img src="@/assets/image/innovatc/icon4.webp">
            <span>企业</span>
          </div>
          <p>传播品牌<br> 扩大销售</p>
        </div>
      </div>
    </div>
    <footerCard name="孙老师" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.jiceng {
  .title {
    margin: 1rem 0 0.7368rem 0;
    @media screen and (max-width: 540px) {
      margin: 33px 0;
    }
  }
  .img1 {
    height: 5.4947rem;
    padding: 0 2.2632rem;
    @media screen and (max-width: 540px) {
      padding: 0 0.5263rem;
      height: 6.3158rem;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    padding: 0.5263rem 0 0.9474rem 0;
    color: #0ca6eb;
    text-align: center;
    font-size: 0.4rem;
    margin: 0;
    @media screen and (max-width: 540px) {
      font-size: 19px;
      width: 68%;
      margin: 0 auto;
      padding: 34px 0 50px 0;
      line-height: 40px;
    }
  }
  .yunying-card {
    margin-top: 1.2632rem;
    justify-content: center;
    display: flex;
    p {
      font-size: 0.2947rem;
      width: 0.5947rem;
      text-align: center;
      padding-top: 1.0526rem;
      @media screen and (max-width: 540px) {
        font-size: 0.6316rem;
      }
    }
    .yunying-box {
      width: 5.9684rem;
      height: 5rem;
      @media screen and (max-width: 540px) {
        width: 80%;
        height: 240px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .text2 {
    color: #0ca6eb;
    font-size: 0.2947rem;
    text-align: center;
    font-weight: 500;
    margin: 0;
    padding: 0.4rem 0 0.8211rem 0;
    @media screen and (max-width: 540px) {
      font-size: 0.6316rem;
      font-weight: 600;
      padding: 19px 0;
    }
  }
  .quanyi {
    background-color: #fafafa;
    padding-bottom: 1.0526rem;
    @media screen and (max-width: 540px) {
      padding-bottom: 3.1579rem;
    }
    .top {
      padding: 1.0526rem 0;
      @media screen and (max-width: 540px) {
        padding: 70px 0;
      }
    }
    .content {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      height: 6.1474rem;
      width: 6.1474rem;
      @media screen and (max-width: 540px) {
        width: 200px;
        height: 200px;
      }
      background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/80847FD9545546A4AB0E544AC336BED5-6-2.png') no-repeat;
      background-size: 100% 100%;
      h4 {
        font-size: 0.2947rem;
        color: #333333;
        font-weight: 700;
        text-align: center;
        margin: 0;
      }
      .bordericon {
        display: flex;
        align-items: flex-end;
        p {
          text-align: center;
          font-size: 0.2526rem;
          color: #272b2d;
          padding: 0 0.2947rem;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
        .icon {
          img {
            display: block;
            width: 0.6316rem;
            height: 0.6316rem;
            margin: 0 auto;
            margin-bottom: 0.0526rem;
          }
          span {
            display: block;
            width: 100%;
            text-align: center;
          }
          text-align: center;
          color: #0ca6eb;
          // width: 0.6316rem;
          font-size: 0.3158rem;
        }
      }
      .left-top {
        position: absolute;
        left: -40%;
        top: -10%;
      }
      .left-bootom {
        position: absolute;
        bottom: -5%;
        left: -40%;
        @media screen and (max-width: 540px) {
          bottom: -5%;
          left: -45%;
        }
      }
      .right-top {
        position: absolute;
        right: -48%;
        top: -10%;
        @media screen and (max-width: 540px) {
          right: -50%;
          top: -10%;
        }
        p {
          text-align: left;
        }
      }
      .right-bottom {
        position: absolute;
        bottom: -5%;
        right: -23%;
      }
    }
  }
}
</style>
